import styled from "styled-components";

export const FullWrap = styled.div`
    // background: #FFF7F4;
    background:rgba(140, 198, 63, 0.1);
    padding-bottom: 3rem;
`;
export const InnerWrap = styled.div`
    padding-top:7rem;
    margin-bottom:5rem;
    @media only screen and (max-width:991px){
        margin-top:0rem;
        padding-top:0rem;
    }
`;

export const Heading = styled.h3`
    font-size: 2.5rem;
    margin-top:3rem;
    margin-bottom: .7rem;
    font-weight: 500;
    line-height: 1.2;
    font-style: normal;
    color: rgba(74, 74, 74, 1.00);
    text-align:center;
    @media only screen and (max-width:767px){
        margin-top:3rem;
        font-size: 1.5rem;
        line-height: 2rem;
    }
`;
export const SubHeading = styled.h5`
    font-weight: 400;
    font-style: normal;
    color: rgba(74, 74, 74, 1.00);
    padding:1.5rem 0px;
    margin-bottom: 1.1rem;
    font-size: 1rem;
    text-align:center;
    @media only screen and (max-width:767px){
        padding:1.5rem 5px;
    }
`;

export const MapWrap = styled.div`
    box-shadow: 0 0.5rem 1rem rgba(220, 195, 197, 0.75) !important;
    margin:1.5rem 0px;
    height:510px;
    width:100%;
    img{
        width:100%;
        @media only screen and (max-width:767px){
            width:100%;
        }
    }
    .marker {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 18px;
        height: 18px;
        background-color: #000;
        border: 2px solid #fff;
        border-radius: 100%;
        user-select: none;
        transform: translate(-50%, -50%);
        &:hover {
          z-index: 1;
        }
      }
`;

export const ResultWrap = styled.div`
    text-align:left;
`;
export const ResultHeading = styled.h3`
    margin:1.5rem 0px;
    font-weight: 400;
    font-style: normal;
    color: rgba(74, 74, 74, 1.00);
    font-size: 1rem;
`;
export const ResultCard = styled.div`
    box-shadow: 0 0.5rem 1rem rgba(220, 195, 197, 0.75) !important;
    margin:1.5rem 0px;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
`;

export const CardTopWrap = styled.div`
    padding: 1.25rem;
    padding-bottom:0px;
`;
export const CardLink = styled.a`
    color: rgba(74, 74, 74, 1.00) !important;
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
    text-decoration: none;
    font-size: 1rem;
    line-height: 1.75rem;
    font-weight: 500;
`;

export const CardInnerHeading = styled.p`
    margin-bottom: 1rem;
    font-weight: 400;
    font-style: normal;
    color: rgba(74, 74, 74, 1.00);
    font-size: 1rem;
`;
export const CardFooter = styled.div`
    padding: .75rem 1.25rem;
    padding-top:0px;
`;
export const CallButton = styled.a`
    background-color: #8cc63f;
    box-shadow: rgba(221, 181, 187, 0.35) 0px 7.5px 12px 0px;
    transition: all 400ms cubic-bezier(0.445, 0.5, 0.55, 0.95);
    color: rgba(255, 255, 255, 1.00);
    text-shadow: 1px 1px 1px rgba(209, 141, 156, .5);
    padding:.5rem 3rem;
    border-radius: 50rem;
    font-weight: 400;
    border: 1px solid transparent;
    font-size: 1rem;
    line-height: 1.5;
    margin:.5rem 0px;
    display: inline-block;
    &:hover{
        color: rgba(255, 255, 255, 1.00);
        text-decoration: none;
    }
`;
export const VisitButton = styled.a`
    margin:.5rem 0px;
    padding:.5rem 3rem;
    border-radius: 50rem;
    background: transparent;
    border: 1px solid rgba(0, 0, 0, .1);
    transition: all 400ms cubic-bezier(0.445, 0.5, 0.55, 0.95);
    color: rgba(164, 164, 164, 1.00);
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 400;
    display: block;
    text-align: center;
    @media only screen and (max-width:991px){
        padding:.5rem 0rem;
    }
    &:hover{
        border: 1px solid #8cc63f;
        color: #8cc63f;
        text-decoration: none;
    }
`;



export const MapFullWrap = styled.div`
&:hover{
    .map-wrap{
        display: block;
   } 
}
`;
export const MarkWrap = styled.div`
    width:220px;
    // height:180px;
    background-color:#fff;
    border-radius:15px;
    padding: 15px;
    box-shadow: 0px 0px 20px -11px #000;
    display: none;
    margin-left: 22px;
    margin-top: -25px;
    z-index: 999999;
    position: relative;
`;
export const MapFirstName = styled.h4`
    color: rgba(74,74,74,1.00);
    font-size: 15px;
    text-transform: uppercase;
`;
export const MapPhoneNumber = styled.p`
    font-size: 14px;
    color: #474f56 !important;
    margin-bottom:5px;
`;
export const MapUrl = styled.p`
    color: #8cc63f;
    text-decoration: underline;
    font-size: 14px;
    margin-bottom:5px;
    word-break: break-all;
`;

export const MarkFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    svg{
        color: #8cc63f;
        font-size:15px;
    }
`;

export const FooterLeftWrap = styled.div`
    display: flex;
    align-items: center;
`;
export const FooterRightWrap = styled.div`
    display: flex;
    align-items: center;
    svg{
        margin:0px 5px;
    }
`;



// WEBPACK FOOTER //
// ./src/component/Map/styles.js